export default {
  title: "Biblioteca",
  icon: "mdi-bookshelf",
  permissions: [
    "compliance",
    "manager",
    "compliance_operational",
    "director",
    "requests_manager",
  ],
  modules: ["requests"],
  sub_items: [
    {
      title: "Biblioteca",
      icon: "fa-book-open",
      name: "LibraryIndex",
    },
    {
      title: "Comunicação",
      icon: "fa-comment",
      name: "CommunicationIndex",
    },
    {
      title: "Podcast",
      icon: "fa-volume-up",
      name: "PodcastIndex",
      params: { type: "podcasts" },
    },
  ],
};
